import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    recordRow: {
        paddingLeft : "5px",
        paddingTop : "10px",
        paddingBottom : "10px",
    },
    labelText: {
        color : "#3c4257",
        fontSize : "18px"
    },
    dialogHeader: {
      color: "#1a1f36",
        paddingBottom: 5,
        boxShadow: "inset 0 -1px #e3e8ee",
        fontFamily: "Rubik, sans-serif",
        fontSize:"20px"
    },
    fieldText: {
        color : "#1a1f36",
        fontSize : "18px"
    },
    timeZoneText: {
        fontSize: "10px"
    },
    buttonBasic: {
      backgroundColor: "#ffffff",
      color: "#1a1f36",
      fontSize: "14px",
      boxShadow:
        " 0 0 0 1px rgb(42 47 69 / 10%), 0 2px 5px 0 rgb(42 47 69 / 10%), 0 1px 1.5px 0 rgb(0 0 0 / 7%), 0 1px 2px 0 rgb(0 0 0 / 8%), 0 0 0 0 transparent",
      paddingLeft: "15px",
      paddingRight: "15px",
      paddingTop: "3px",
      paddingBottom: "3px",
      textTransform: "none",
    },
    buttonAction: {
        
        color: "#1a1f36",
        fontSize: "14px",
        boxShadow: "rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;"
    }
}));

const ClassDialog = (props) => {
    const classes = useStyles();
  return (
    <Dialog
      open={props.open}
      onClose={props.close}
      aria-labelledby="alert-dialog-title"
      maxWidth="xs"
      zIndex= {99999}
    >
      <Grid item style={{paddingLeft:"15px", paddingRight:"15px"}}>
        <DialogTitle style={{minWidth:"300px"}} className={classes.dialogHeader} id="alert-dialog-title">{props.classInfo.startTime} <span className={classes.timeZoneText}>({props.classInfo.timeZone})</span></DialogTitle>
      </Grid>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.recordRow}>
              <span className={classes.labelText}>Class# : </span>
              <span className={classes.fieldText}>{props.classInfo.classNumber}</span>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.recordRow}>
              <span className={classes.labelText}>Service : </span>
              <span className={classes.fieldText}>{props.classInfo.serviceName}</span>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.recordRow}>
              <span className={classes.labelText}>Location : </span>
              <span className={classes.fieldText}>{props.classInfo.siteName}</span>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.recordRow}>
              <span className={classes.labelText}>Total Attendees : </span>
              <span className={classes.fieldText}>{props.classInfo.bookedSeats}</span>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.dialogFooter}>
        <Button
          className={classes.buttonBasic}
          onClick={() => {
            props.close();
          }}
        >
          Close
        </Button>
        <Button
          className={classes.buttonBasic}
          onClick={() => {
            props.classDetails();
          }}
          style={{color:"white", backgroundColor:"#0079fc"}}
        >
          View Details
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ClassDialog);
